export default "__VITE_ASSET__stx5PbjQ__"